var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{attrs:{"fs":_vm.shippingFields,"api":"shippings","title":"Delivery","addLink":"/admin/shippings/new","editLink":"/admin/shippings"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }